import { Injectable } from '@angular/core';
import {TagDto, TagRequestDto} from "app/models/menu.model";
import {firstValueFrom} from "rxjs";
import {environment} from "environments/environment";
import {HttpClient, HttpHeaders} from "@angular/common/http";

@Injectable({
  providedIn: 'root'
})
export class TagService {
  private requestPath = `${environment.posBaseUrl}/api/front/tags`;
  private headers: HttpHeaders = new HttpHeaders({
    'Content-Type': 'application/json',
  });

  constructor(
    private http: HttpClient,
  ) { }

  async create(menuId: string, requestDto: TagRequestDto) : Promise<TagDto> {
    try{
      return await firstValueFrom(
        this.http.post<TagDto>(
          this.requestPath + "/" + menuId,
          requestDto,
          {
            headers: this.headers,
          }
        )
      );
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }

  async update(tagId: string, requestDto: TagRequestDto) : Promise<TagDto> {
    try {
      return await firstValueFrom(
        this.http.put<TagDto>(
          this.requestPath + "/" + tagId,
          requestDto,
          {
            headers: this.headers,
          }
        )
      );
    }
    catch(exception){
      console.log('exception', exception);
      return exception;
    }
  }

  async delete(tagId: string) {
    try {
      return await firstValueFrom(this.http.delete<null>(
        this.requestPath + "/" + tagId,
      ))
    }
    catch(exception){
      // TODO: какая-то ошибка
      console.log('exception', exception);
      return exception;
    }
  }
}
